import isHotkey from 'is-hotkey';
import SlateHelpers from './SlateHelpers';
export default (function (config) { return function (e, editor, next) {
    var slateHelpers = new SlateHelpers(editor, config);
    var hotKey = config.hotKey;
    if (config.isDisabled && config.isDisabled(editor)) {
        return;
    }
    if (isHotkey(hotKey, e.nativeEvent)) {
        if (slateHelpers.isActive()) {
            slateHelpers.remove();
        }
        else {
            slateHelpers.add(config.getInitialData ? config.getInitialData() : null);
        }
        e.preventDefault();
        return true;
    }
    else {
        return next();
    }
}; });
//# sourceMappingURL=simpleToggleHotKeyHandler.js.map